import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Intake Coordinates List with Query
export const getIntakeCoordinatesListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_INTAKE_COORDINATES_LIST}?${stringifyParams(
			params
		)}`
	);
};

// Get Intake Coordinates List
export const getIntakeCoordinatesList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['createdAt:desc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_INTAKE_COORDINATES_LIST}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Intake Coordinates
export const getIntakeCoordinatesItem = (intake_coordinates_id, populate = []) => {
	const populateParam = populate.length > 0 ? `?${stringifyParams({ populate })}` : '';
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_INTAKE_COORDINATES}${intake_coordinates_id}${populateParam}`
	);
};

// Add New Intake Coordinates
export const addNewIntakeCoordinatesApi = intake_coordinates => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_INTAKE_COORDINATES}`,
		intake_coordinates
	);
};

// Update Intake Coordinates
export const updateIntakeCoordinatesApi = intake_coordinates => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_INTAKE_COORDINATES}${intake_coordinates._id}`,
		intake_coordinates
	);
};

// Delete Intake Coordinates
export const deleteIntakeCoordinatesApi = intake_coordinates_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_INTAKE_COORDINATES}${intake_coordinates_id}`
	);
};
